const noticeList = () => import('@/pages/notice/list')

export default [
  {
    path: '/notice-list',
    component: noticeList,
    name: 'noticeList',
    meta: [
      {
        name: '通知管理',
        url: '/notice-list'
      }
    ]
  }
]
